import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components';
import { media } from 'utils/media';

export const Container = styled.div<{
  template?: any;
  background?: string;
  auxColor: string;
}>`
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  background: ${({ background }) => `${background}`};
  overflow: hidden;

  &select,
  option {
    color: black !important;
  }

  & .swiper-wrapper {
    display: flex;
    align-items: center;
  }
  
  & .swiper-pagination {
    position: relative;
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0 !important;
    
    & .swiper-pagination-bullet {
      margin: 0 5px;
    }
  }

  .activeSlider {
    opacity: 1;
    width: 25px;
    border-radius: 100px;
    background-color: #174f68 !important;
  }

  .player-button {
    position: absolute;
    right: 1rem;
    top: 35%;
    height: auto;
    width: 40px;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    transition: all .2s;
    cursor: pointer;

    &:hover{
      background-color: #174f68 !important;
    }

    & svg {
      height: 30px;
      width: 30px;
      fill: #fff;
      padding: 5px 0;
    }
  }

  & > div:first-child {
    z-index: 999;
    background: ${({ background }) => (background ? background : `#fff`)};
  }

  & .button-color {
    padding-left: 60px;

    & .picker-svg {
      position: absolute;
      left: 15px;
      top: 15px !important;
    }
    & input[type='color'] {
      position: absolute;
      width: 50px;
      height: 100%;
      left: -1px;
      border: none;
      background: none;
      cursor: pointer;
      margin: 0 !important;
      padding: 0 !important;

      &::-webkit-color-swatch-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0;
        top: -1.2rem;
      }

      &::-webkit-color-swatch {
        border: solid 2px transparent;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border: 1px solid #174f68;
      }
    }
  }
`;

export const Header = styled.header<{ fontColor?: string }>`
  max-width: 130em;
  width: 100%;

  height: 7rem;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 10;

  & > div {
    padding: 1.5rem 0;
    display: flex;

    &:first-child {
      flex: 1;
    }

    &:last-child button {
      display: none;
    }

    &:last-child nav ul {
      display: grid;
      grid-template-columns: auto auto auto;
      grid-column-gap: 45px;
      list-style: none;

      & a,
      & a:link,
      & a:visited {
        font-family: 'Nunito';
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: ${({ fontColor }) => fontColor} !important;
        text-decoration: none;
      }
    }
  }

  ${media('<=tablet')} {
    padding: 0 34px;

    & > div:last-child nav {
      display: none;
    }
    & > div:last-child button {
      background-color: transparent;
      outline: none;
      border: none;
      display: flex;
      cursor: pointer;
    }
  }
`;

export const SecondNavBar = styled.section<{ fontColor?: any }>`
  box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 34px;
  background: #fff6e8;

  & li a {
    & > span:first-child {
      display: block;
      margin-right: 1rem;
    }
    & > span:nth-child(3) {
      display: none;
    }
  }

  & > div nav ul {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-column-gap: 45px;
    list-style: none;
    max-width: 100vw;

    @media (max-width: 374px) {
      grid-column-gap: 35px;
    }

    & a,
    & a:link,
    & a:visited {
      font-family: 'Nunito';
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: ${({ fontColor }) => (fontColor ? fontColor : `#174F68`)};
      text-decoration: none;
      display: flex;
      align-items: center;

      & > span:last-child {
        display: none;
      }
      & > span:first-child {
        display: block;
      }
    }
  }
  ${media('<=tablet')} {
    & ul {
      padding: 0 !important;
    }
    & li a {
      & > span:nth-child(2) {
        display: none;
      }
      & > span:first-child {
        display: block;
      }
      & > span:nth-child(3) {
        display: block;
      }
    }
  }
`;

export const Footer = styled.footer<{ bgColor?: string; template?: any; fontColor?: string }>`
  padding: 30px 102px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  background-color: ${({ bgColor }) => (bgColor ? bgColor : '#174F68')};
  color: ${({ fontColor }) => (fontColor ? fontColor : '#fff')} !important;
  & > div {
    display: flex;

    &:nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;

      & > p {
        font-family: 'Nunito';
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;
      }
    }
    &:last-child {
      display: flex;
      flex-direction: row;
      list-style: none;

      & ul {
        display: flex;
        flex-direction: row;
        list-style: none;

        & > li {
          margin-left: 1.5rem;
        }
      }
    }
  }
  ${media('<=tablet')} {
    padding: 77px 34px;
    grid-template-columns: 1fr;

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      &:first-child {
        grid-row-start: 2;
        grid-row-end: 3;
      }
      &:nth-child(2) {
        grid-row-start: 0;
        grid-row-end: 1;
      }
      &:last-child {
        grid-row-start: 1;
        grid-row-end: 2;

        & ul {
          padding: 0;
        }
      }
    }
  }

  & > span {
    display: none;
  }
`;

export const AsideNavigation = styled.aside<{ toggle: boolean }>`
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  left: ${({ toggle }) => (toggle ? 0 : -100)}%;
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.2s ease-in-out;

  & nav {
    min-width: 250px;
    width: fit-content;
    padding: 34px;
    background-color: #fff6e8;
    height: 100%;

    & > ul {
      list-style: none;
      display: flex;
      flex-direction: column;
      margin: 0;
      padding: 0;

      & > li {
        & a,
        & a:link,
        & a:visited {
          font-family: 'Nunito';
          font-size: 16px;
          font-weight: 500;
          line-height: 34px;
          text-decoration: none;
        }
      }
    }
  }
`;

export const ContainerShare = styled.a`
  display: flex;
  align-items: center;
`;

export const CenterLinks = styled.div`
  justify-content: space-evenly !important;
  display: flex;

  p {
    cursor: pointer;
  }

  @media (max-width: 820px) {
    display: grid !important;
    margin-bottom: 2rem;
  }
`;

export const LogoItems = styled.div`
  display: grid !important;
  justify-items: center !important;

  .mobile-copyright {
    display: none;
  }

  p {
    font-size: 12px;
  }

  @media (max-width: 820px) {
    .mobile-copyright {
      display: block;
    }
    .web-copyright {
      display: none;
    }
  }
`;

export const InstaLogo = styled.div`
  margin-top: 1.2rem;
  @media (max-width: 820px) {
    display: none !important;
  }
`;

export const MobileInstaLogo = styled.div`
  display: none;
  @media (max-width: 820px) {
    display: block;
    list-style: none;
    margin-bottom: 2rem;
    margin-left: -1rem;
  }
`;

export const Content = styled.main<{
  color: string;
  bgColor?: any;
  background?: string | unknown;
  backgroundColor?: string | unknown;
  editedCover?: string;
  auxColor: string;
  hasImage?: boolean;
}>`
  font-family: 'Nunito';
  color: ${({ color }) => color} !important;
  background-color: ${({ bgColor }) => (bgColor ? bgColor : `#fff6e8`)} !important;

  & .bulletActive {
    background: ${({ color }) => (color ? color : '#fff')};
    opacity: 1;
  }

  .modal-preview {
    background-color: red;
  }

  & button {
    color: #ffffff;
    padding: 12px 25px;
    background-color: #174f68;
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    outline: none;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    //max-width: fit-content;

    &[disabled] {
      background-color: rgba(217, 217, 217, 1);
      cursor: default !important;
    }
  }

  & h2 {
    font-family: 'P22 Mackinac Pro';
    font-size: 28px;
    font-weight: 500;
    margin: 52px 0;
  }

  & h4 {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    text-align: center;
    margin-bottom: 30px;
  }

  & > section {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;

    &:first-child {
      overflow: hidden;
      align-items: flex-end;

      & > img:first-child {
        position: absolute;
        top: 0;
        left: 0;
      }
      & > img:last-child {
        position: absolute;
        right: 0;
      }
    }
    &:nth-child(2) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 300px;

      & > div {
        max-width: 525px;
        &:first-child {
          display: flex;
          justify-content: center;
          align-items: center;
          /*max-width: none !important;*/
          width: 100%;
          padding-top: 3rem;
          margin-top: -7rem;

          & > h1:nth-child(3) {
            text-align: center;
          }

          & div {
            padding: 0 4rem;
            padding-bottom: 7rem;
            max-width: 525px;
            & h1 {
              font-family: 'P22 Mackinac Pro';
              font-size: 64px;
              text-align: center;
              font-weight: 500;
            }
          }
        }
        &:nth-child(2) {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 30px;
          padding: 1rem 0;
          width: 100%;

          & > div {
            font-size: 14px;
            &:first-child,
            &:nth-child(2) {
              font-family: 'Nunito';
              font-size: 18px;
              font-weight: 500;
              line-height: 42px;
              letter-spacing: 0em;
              text-align: left;
            }
          }
        }
      }
    }
    &:nth-child(3) {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 7rem 0;

      & > p {
        text-align: center;
        font-size: 26px;
        max-width: 755px;
      }
    }
    &:last-child {
      display: flex;
      justify-content: center;
      background-position: bottom !important;
      background-size: 100% auto !important;
      min-height: 850px;
      background-repeat: no-repeat;
      align-items: flex-start;

      & > img {
        position: absolute;

        &:first-child {
          top: -5rem;
          left: 0;
        }
        &:last-child {
          right: 0;
        }
      }

      & > div {
        min-width: 400px;
        height: fit-content;
      }
    }
  }

  ${media('<=tablet')} {
    & > section:first-child {
      background-size: contain;

      & > img:first-child {
        top: -4rem;
        left: 0;
      }
      & > img:last-child {
        right: 0;
      }
    }
    & > section:nth-child(2) {
      padding: 0 34px;
    }
    & > section:nth-child(3) {
      padding: 7rem 34px;

      & p {
        font-size: 20px;
      }
    }
    & > section:last-child {
      position: relative;
      & > img {
        &:first-child {
          top: 0;
          left: 0;
        }
        &:last-child {
          right: 0;
        }
      }

      & > div {
        min-width: 300px;
        height: fit-content;

        position: absolute !important;
        bottom: 25% !important;
      }
    }
  }
  ${media('<=phone')} {
    & > section:first-child {
      min-height: 200px;
      & > img:first-child {
        top: -15rem;
        left: 0;
      }
      & > img:last-child {
        top: -15rem;
        right: 0;
      }
    }
    & > section:nth-child(2) {
      & > div {
        &:first-child {
          padding: 4rem;
          & > h1 {
            font-size: 34px;
          }
        }
        &:nth-child(2) {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 30px;
          padding: 1rem 0;
          width: 100%;

          & > div {
            font-size: 12px;
            &:first-child,
            &:nth-child(2) {
              font-family: 'Nunito';
              font-size: 14px;
              font-weight: 500;
              line-height: 42px;
              letter-spacing: 0em;
              text-align: left;
            }
          }
        }
      }
    }
    & > section:last-child {
      align-items: center;
      min-height: 500px;
      & > img {
        &:first-child {
          top: 50px;
          left: 0;
        }
        &:last-child {
          /* bottom: -30px; */
          right: 0;
        }
      }
      & > div {
        min-width: 250px;
        height: fit-content;

        position: absolute !important;
        bottom: 5% !important;
      }
    }
  }
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 375px) {
    & > section:first-child {
      background-size: 100% auto !important;
      height: ${({ hasImage }) => (hasImage ? '150px' : '250px')} !important;
      min-height: auto;
    }
  }
  /* Extra small devices (phones, 600px and down) */
  @media (min-width: 375px) and (max-width: 600px) {
    & > section:first-child {
      background-size: ${({ hasImage }) => (hasImage ? '100% auto !important' : 'auto')};
      height: ${({ hasImage }) => (hasImage ? '176px' : '350px')} !important;
    }
    & > section:last-child {
      background-size: ${({ hasImage }) => (hasImage ? 'cover !important' : 'auto')};
      height: ${({ hasImage }) => (hasImage ? '260px' : '450px')} !important;
    }
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    & > section:first-child {
      background-size: ${({ hasImage }) => (hasImage ? '100% auto !important' : 'auto')};
      height: ${({ hasImage }) => (hasImage ? '300px' : '500px')} !important;
    }
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    & > section:first-child {
      height: 380px !important;
    }
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    & > section:first-child {
      height: 460px !important;
    }
  }

  @media only screen and (min-width: 1100px) {
    & > section:first-child {
      height: 550px !important;
    }
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    & > section:first-child {
      height: 610px !important;
      background-size: cover;
    }
  }

  @media only screen and (min-width: 1400px) {
    & > section:first-child {
      height: 700px !important;
    }
  }

  @media only screen and (min-width: 1500px) {
    & > section:first-child {
      height: 750px !important;
    }
  }

  @media only screen and (min-width: 1700px) {
    & > section:first-child {
      height: 800px !important;
    }
  }

  @media only screen and (min-width: 1800px) {
    & > section:first-child {
      height: 815px !important;
      background-size: cover;
    }
  }
`;

export const HeaderSection = styled.section<{
  cover?: string;
  mobileCover?: string;
  hasCover?: boolean;
  bgColor?: string;
}>`
  ${({ cover, bgColor, hasCover }) =>
    !cover
      ? `background-color: ${bgColor};display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;`
      : hasCover
        ? `background: linear-gradient(transparent 40%,${bgColor} 92%,${bgColor} 100%), url(` +
        cover +
        `) !important;display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;`
        : `background: url(` +
        cover +
        `) !important;display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;`};
  height: 815px !important;
  background-size: center !important;
  background-repeat: no-repeat !important;
  background-position: center top !important;
  @media (max-width: 600px) {
    ${({ mobileCover, bgColor }) =>
    !mobileCover
      ? `background-color: ${bgColor};display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;`
      : `background: linear-gradient(transparent 40%,${bgColor} 92%,${bgColor} 100%), url(` +
      mobileCover +
      `) !important;display: flex; justify-content: center; align-items:center; margin-bottom: 1rem !important;`};

    background-repeat: no-repeat !important;
    background-position: top !important;
    background-size: ${({ hasCover }) => (!hasCover ? 'auto' : '100% auto !important')} !important;
    height: ${({ hasCover }) => (!hasCover ? '300px' : '200px')} !important;
  }
  @media only screen and (min-width: 600px) and (max-width: 992px) {
    height: 400px !important;
  }
  @media (max-width: 350px) {
    height: 160px !important;
  }
`;

export const FooterSection = styled.section<{ imageURL?: string; mobileCover?: string; bgColor?: string }>`
  ${({ imageURL, bgColor }) =>
    !imageURL
      ? `background-color: ${bgColor};display: flex; justify-content: center; align-items:center`
      : `background-image: url(${imageURL}) !important;display: flex; justify-content: center; align-items:center;}`};
  height: 815px !important;
  min-height: auto !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: bottom !important;

  @media (max-width: 600px) {
    height: 260px !important;

    ${({ mobileCover, bgColor }) =>
    !mobileCover
      ? `background-color: ${bgColor};display: flex; justify-content: center; align-items:center`
      : `background-image: url(${mobileCover}) !important;display: flex; justify-content: center; align-items:center;}`};
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 100% auto !important;
    margin-top: -80px !important;
  }

  @media only screen and (min-width: 600px) and (max-width: 992px) {
    height: 400px !important;
  }
  @media only screen and (max-width: 350px) {
    height: 160px !important;
  }
`;
export const MessageSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 7rem;
  padding: 0 !important;
  width: 100%;
  overflow: hidden;

  & h2 {
    margin-bottom: 2rem;
  }

  & .bulletActive {
    background: white;
    opacity: 1;
  }

  & .swiper {
    width: 100%;
    max-width: 1200px;
    padding: 0;
    overflow: visible;
  }

  & .swiper-wrapper {
    align-items: center;
  }

  & .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px !important; /* Fixed width to match the component */
  }

  & .message {
    font-family: 'Nunito';
    width: 100%;
    max-width: 400px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    padding: 30px;
    font-size: 16px;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);

    p {
      font-family: inherit;
      font-weight: 700;
      line-height: 27px;
      font-size: inherit;
      letter-spacing: 0em;
      text-align: left;
      margin-bottom: 15px;
      overflow-wrap: break-word;
      word-break: break-word;
    }

    span {
      font-family: inherit;
      font-size: inherit;
      font-weight: 400;
      line-height: 30px;
      letter-spacing: 0em;
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      & > span {
        display: flex;
        align-items: center;
      }
    }
  }
  
  & > *:last-child {
    max-width: 100%;
    padding: 0 34px;
  }

  @media (max-width: 768px) {
    & .swiper {
      padding: 0 10px;
    }
    
    & .message {
      padding: 20px;
      max-width: 300px;
    }
    
    & .swiper-slide {
      width: 300px !important;
    }
  }

  @media (max-width: 480px) {
    & .message {
      max-width: 280px;
      padding: 15px;
    }
    
    & .swiper-slide {
      width: 280px !important;
    }
  }
`;
export const Switch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  margin-right: 8px;

  & input {
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
  }

  & label {
    position: relative;
    cursor: pointer;
    width: 40px;
    height: 20px;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
    margin: 0;
    padding: 0;
    display: inline-block;
  }

  & label:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  & input:checked + label {
    background-color: #5cc9aa;
  }

  & input:checked + label:before {
    transform: translateX(20px);
  }
`;
export const CentredSpan = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const TitleSection = styled.section`
  align-self: center;
  padding: 0 4rem;

  & h1 {
    font-size: 62.6726px !important;
    max-width: 872px;
    text-align: center;
    overflow-wrap: anywhere !important;
  }

  ${media('<=tablet')} {
    padding: 0 2rem !important;
    min-height: auto !important;
    & h1 {
      font-size: 40px !important;
      max-width: 600px;
    }
  }

  ${media('<=phone')} {
    & h1 {
      font-size: 35px !important;
      max-width: 250px;
    }
  }
`;

export const ProgressiveSection = styled.section<{ fontColor?: string }>`
  display: flex;
  padding: 0 4rem;

  & > div {
    display: flex;
    flex-direction: row;
    flex: 1;
    align-self: center;
    max-width: 130em;
    margin: 0 auto;
    gap: 2rem;

    & > div {
      flex: 1;

      &:first-child {
        display: flex;
        flex-direction: column;

        & p {
          font-family: 'Nunito';
          font-size: 30px;
          font-weight: 500;
          line-height: 50px;
          text-align: left;
          max-width: 90%;
        }

        & > div {
          max-width: 90%;

          & strong {
            font-family: 'Nunito';
            font-size: 22px;
            font-weight: 500;
            text-align: left;
          }

          & input,
          textarea {
            position: relative;
            border: 1px solid ${({ fontColor }) => (fontColor ? fontColor : '#174F68')};
            background-color: transparent;
            width: 100%;
            border-radius: 8px;
            padding: 1.2rem 0.9rem;
            outline: none;
            font-size: 16px;
            margin-top: 1rem;
            color: ${({ fontColor }) => (fontColor ? fontColor : '#174F68')};
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;

            ::placeholder {
              color: ${({ fontColor }) => (fontColor ? fontColor : '#174F68')};
              opacity: 0.5;
            }
            :disabled {
              background-color: rgba(0, 0, 0, 0.4);
            }
          }

          & select {
            position: relative;
            border: 1px solid ${({ fontColor }) => (fontColor ? fontColor : '#174F68')};
            background-color: transparent;
            width: 100%;
            border-radius: 8px;
            padding: 1.2rem 0.9rem;
            outline: none;
            font-size: 16px;
            margin-top: 1rem;
            color: ${({ fontColor }) => (fontColor ? fontColor : '#174F68')};
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;

            ::placeholder {
              color: ${({ fontColor }) => (fontColor ? fontColor : '#174F68')};
              opacity: 0.5;
            }
            :disabled {
              background-color: rgba(0, 0, 0, 0.4);
            }
          }

          & textarea {
            resize: none;
            height: 127px;
          }

          &:last-child {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            gap: 10px;
            & button {
              width: 100%;
              text-align: center;
            }

            & > span {
              flex: 1;
              :last-child {
              }
            }
          }
        }
      }

      &:last-child {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  ${media('<=tablet')} {
    & > div {
      flex-direction: column-reverse;
      & > div {
        &:first-child {
          & p {
            font-size: 18px;
            line-height: 30px;
            max-width: 100%;
            padding: 0 1.5rem;
          }
          & > div {
            max-width: 100%;
          }
        }
      }
    }
  }

  ${media('<=phone')} {
    & > div {
      display: flex;
      flex-direction: column-reverse;

      & p {
        line-height: 26px !important;
        font-size: 16px !important;
      }
    }
  }
`;

export const ContainerDonationSuggestions = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  padding: 0 15em;
  max-width: 130em;
  margin: 32px auto;
  justify-content: center;

  ${media('<=tablet')} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-self: center;
  }

  ${media('<=phone')} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 0 !important;
  }
`;

export const ButtonDonnationValue = styled.button<{ selected: boolean }>`
  font-size: 12px;
  padding: 9px 20px;
  font-weight: 600;
  border: ${({ selected }) => (selected ? 'solid 1px #fff' : 'none')}!important;
`;

export const TaxValuesTextNote = styled.span`
  font-size: 14px;
  padding: 0 15em;
  margin: 0 auto !important;
  display: block;
  width: 100%;
  text-align: center;

  @media (max-width: 500px) {
    padding: 0;
  }
`;

export const QuotasSection = styled.section<{ fontColor?: string }>`
  display: flex;
  flex-direction: column;
  padding: 0 4rem;

  & > div:last-child {
    width: 100%;
    & > div {
      flex: 1;

      margin-bottom: 2rem;

      &:last-child {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        & p {
          font-family: 'Nunito';
          font-size: 30px;
          font-weight: 500;
          line-height: 50px;
          text-align: left;
          max-width: 90%;
        }

        & > div {
          :not(:last-child) {
            margin-bottom: 2rem;
          }

          & strong {
            font-family: 'Nunito';
            font-size: 22px;
            font-weight: 500;
            text-align: left;
            text-align: left !important;
          }

          & input,
          textarea {
            border: 1px solid ${({ fontColor }) => (fontColor ? fontColor : '#174F68')};
            background-color: transparent;
            width: 100%;
            border-radius: 8px;
            padding: 1.2rem 0.9rem;
            outline: none;
            font-size: 16px;
            margin-top: 1rem;
            color: ${({ fontColor }) => (fontColor ? fontColor : '#174F68')};
            margin-bottom: 2rem;

            ::placeholder {
              color: ${({ fontColor }) => (fontColor ? fontColor : '#8b8ee8')};
            }
          }

          & textarea {
            resize: none;
            height: 127px;
          }

          &:last-child {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
`;

{
  /**
export const SupportersSection = styled.section<{ color: string }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 80%;
`;

*/
}
export const PrivateAlbumSection = styled.section<{ borderColor?: string }>`
  margin: 4rem 0;

  & > div {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 100px;

    & > div {
      min-width: 800px;
      display: flex;
      flex-direction: column;

      & h4 {
        text-align: left;
      }

      & > div {
        max-width: 800px;
        &:nth-child(2) {
          width: 100%;
          min-height: 184px;
          border: 1px solid ${({ borderColor }) => (borderColor ? borderColor : 'rgba(139, 142, 232, 0.5)')};
          border-radius: 8px;
          margin-bottom: 2rem;
          padding: 1rem;

          & > * {
            height: 100%;
          }
        }
      }
    }

    .swiper-wrapper {
      justify-content: flex-start;
    }

    .card {
      position: relative;
      height: 100%;
      width: 100%;

      & img {
        max-width: 184px;
        min-height: auto;
        background-color: #ffffff;
      }
      & > span:last-child {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        top: 8px;
        right: 8px;
        height: 35px;
        width: 35px;
        border-radius: 50%;
        background-color: rgba(2, 86, 130, 0.5);
        cursor: pointer;
      }
    }

    & > img {
      position: absolute;

      &:first-child {
        bottom: 0;
        left: 0;
      }
      &:last-child {
        right: 0;
      }
    }

    ${media('<=tablet')} {
      padding: 0 34px;
      max-width: 100% !important;
      & > div {
        min-width: auto;
        width: 100%;
      }
      & > img {
        position: absolute;
        display: none;
      }
    }

    ${media('<=phone')} {
    }
  }
`;

export const PublicAlbumSection = styled.section<{ pageSize: number }>`
  margin-bottom: 7rem;
  width: 100%;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    .swiper-pagination {
      position: absolute;
      text-align: center;
      transition: opacity 0.3s;
      transform: translateZ(0);
      z-index: 1;
    }

    & .card {
      display: flex;
      align-items: center;
      justify-items: center;
      cursor: pointer;

      & img {
        max-width: 280px;
        min-height: auto;
        background-color: #ffffff;
      }
    }

    & > *:last-child {
      max-width: 100%;
      padding: 0 34px;
    }

    .swiper-button-next,
    .swiper-button-prev {
      position: absolute;
      top: 35%;
      width: 27px;
      height: 54px;
      margin-top: -22px;
      z-index: 999;
      cursor: pointer;
      background: transparent;
      border: none;
    }

    .swiper-button-next:before,
    .swiper-button-prev:before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 26px;
      height: 26px;
      border-top: 3px solid #333;
      border-right: 3px solid #333;
      transform-origin: center center;
    }

    .swiper-button-next:before {
      transform: translate(-50%, -50%) rotate(45deg);
      margin-left: -2.5rem;
    }

    .swiper-button-prev:before {
      transform: translate(-50%, -50%) rotate(-135deg);
      margin-left: 2.5rem;
    }

    @media (min-width: 601px) {
      .swiper-button-next:not(.swiper-button-disabled),
      .swiper-button-prev:not(.swiper-button-disabled) {
        display: block !important;
      }
    }
  }
  .swiper-wrapper {
    display: flex;
    justify-content: ${({ pageSize }) => (pageSize > 1 ? 'flex-start !important' : 'center !important')};
    align-items: center;
  }
`;

export const SubmitContainer = styled.div`
  position: fixed;
  bottom: -7rem;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background-color: #fff;
  height: 7rem;
  box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
  width: 100%;

  & > div {
    max-width: 130em;

    display: flex;
    align-items: center;
    flex-direction: row;
    & > div {
      display: flex;
    }

    & strong {
      margin-right: 2rem;
      font-size: 16px;
    }
  }
`;

export const SendMessageSection = styled.section<{ fontColor?: string }>`
  display: flex;
  flex-direction: column;

  & > div {
    width: 646px;

    & label {
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
    }

    input,
    textarea {
      border: 1px solid ${({ fontColor }) => fontColor || '#8b8ee899'};
      background-color: transparent;
      width: 100%;
      border-radius: 8px;
      padding: 1.2rem 0.9rem;
      outline: none;
      font-size: 16px;
      margin-top: 1rem;
      color: ${({ fontColor }) => fontColor || '#8b8ee899'};
      resize: none;
      margin: 30px 0;

      ::placeholder {
        color: ${({ fontColor }) => fontColor || '#8b8ee899'};
      }
    }

    & textarea {
      height: 127px;
    }
  }

  ${media('<=tablet')} {
    & > div {
      width: auto;
      min-width: 300px;
    }
  }
`;

export const ShareSection = styled.section`
  display: flex;
  flex-direction: column;
  margin: 14rem 0;
  & h2 {
    text-align: center !important;
  }
`;

export const EditableContent = styled(TextareaAutosize)`
  background-color: transparent;
  text-align: center;
  color: inherit !important;
  font-family: inherit !important;
  font-size: inherit !important;
  font-style: inherit !important;
  border: solid 1px transparent;
  outline: none;
  max-width: 1200px;
  resize: none;

  &::-webkit-scrollbar {
    display: none; /* Hide scrollbar */
  }
`;
export const SupporterList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  & > li {
    display: flex;
    align-items: center;
  }
`;

export const SupporterItem = styled.li`
  width: 220px;
  margin: 0.8rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;

  img {
    max-width: 60px;
    margin: 5px;
  }

  p {
    color: #6b6b6b;
  }

  @media (max-width: 768px) {
    justify-content: space-evenly;
    margin: 0.4rem;
    width: 40%;

    img {
      max-width: 55px;
      margin: 5px;
    }
  }

  strong {
    font-weight: bold;
    font-size: 15px;
  }

  span {
    font-weight: bold;
    font-size: 15px;
    color: #77c277;
  }

  @media (max-width: 500px) {
    width: 80%;
  }

  ${media('<=tablet')} {
    width: 100% !important;
  }
`;

export const Supporters = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  max-width: 100%;
  padding: 20px;

  h2 {
    font-family: 'P22 Mackinac Pro';
    color: #174f68;
    margin-top: 35px;
    font-size: 27px;
  }
`;

export const DonateInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 600px;

  & > div {
    :first-child {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  ${media('<=tablet')} {
    min-width: 100% !important;
  }
`;

export const FixedDonateResumeContainer = styled.div`
  position: fixed !important;
  z-index: 999;
  background-color: #fff;
  width: 100%;
  height: fit-content;
  padding: 10px;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
  display: none;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    &:first-child {
      font-size: 23px;
      color: #174f68 !important;
      display: flex;
      flex-direction: column;
    }

    & strong {
      margin: 0 5px;
    }

    & svg {
      fill: #000;
      color: #000;
      font-size: 16px;
    }
  }

  ${media('<=tablet')} {
    display: flex;
  }
`;
export const PaginateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
`;

export const VerificationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 8px;
`;